module.exports =
  '_ANALYSIS_EVENT':
    'TITLE': 'スコア分析'
    'USER_NAME_OF_SCORE_ANALYSIS': "さんのスコア分析 "
    'UPGRADE':
      'COURSE_STATS': 'コース別分析機能'
      'SCATTER': 'スコア/目標値分布図機能'
      'MESSAGE': 'こちらの機能は有料会員向け機能です。<br/>機能詳細について下記リンクボタンをご覧ください。'
      'UPGRADE_NOW': '機能詳細はこちら'
    'PERIOD_FILTER':
      'LAST_1_YEAR': '直近1年'
      'LAST_6_MONTHS': '直近6ヶ月'
      'LAST_3_MONTHS': '直近3ヶ月'
      'LAST_YEAR': '去年'
      'THIS_YEAR': '今年'
    'DETAILED_ANALYSIS':
      'MY_DATA': "マイデータ"
      'GOAL': "目標"
      'MY_AVG': "平均"
      'BEST_SCORE': "ベストスコアラウンド"
      'WORST_SCORE': "ワーストスコアラウンド"
      'ALL_MEMBERS': "会員平均"
      'AVG_TOTAL_SCORE_TITLE': "平均トータルスコア"
      'NUMBER_OF_ROUNDS': "ラウンド数合計"
      'AVG_TOTAL_SCORE': "平均トータルスコア"
      'PUTT_TITLE': "パット分析"
      'AVG_PUTT': "ひとホールあたりの平均パット数"
      'RAT_AVG_PUTT': "パーオン時の平均パット数"
      'RAT_FAIRWAY_TITLE': "フェアウェイキープ"
      'FAIRWAY_CENTER': "フェアウェイキープ率 （％）"
      'FAIRWAY_RIGHT': "右ミス （％）"
      'FAIRWAY_LEFT': "左ミス （％）"
      'GIR_ANALYSIS_TITLE': "GIR分析"
      'RAT_PAR_ON': "パーオン率 （％）"
      'RAT_BOGEY_ON': "ボギーオン率 （％）"
      'STROKE_ANALYSIS_TITLE': "ストローク分析"
      'AVG_STROKE_PAR3': "平均ストローク（Par 3）"
      'AVG_STROKE_PAR4': "平均ストローク（Par 4）"
      'AVG_STROKE_PAR5': "平均ストローク（Par 5）"
      'RAT_RECOVERY': "リカバリー率 （％）"
      'SCORE_ANALYSIS_TITLE': "スコア分析"
      'RAT_UNDER_EAGLE': "イーグル以上 （％）"
      'RAT_BIRDIE': "パーディ （％）"
      'RAT_PAR': "パー （％）"
      'RAT_BOGEY': "ボギー （％）"
      'RAT_DBOGEY': "ダブルボギー （％）"
      'RAT_OVER_TBOGEY': "トリプルボギー以上 （％）"
      'SAND_SAVES_TITLE': "ガードバンカー"
      'RAT_SAND_SAVE': "Scrambling from the Sand （％）"
    'SCATTER_CHART':
      'SCORE': 'SCORE'
      'PUTT': 'PUTT'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/analysis-event/i18n/ja.coffee